import LegacySplitButton from './LegacySplitButton';
export default LegacySplitButton;
